// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferHistorySpoilerRequestV2Schema {
  /** Тип сделки **/
  dealType?: EDealType;
  /** Идентификатор дома **/
  houseId?: number;
  /** Идентификатор объявления **/
  offerId?: number;
  /** Количество комнат **/
  roomsCount?: ERoomsCount;
  /** Площадь объекта **/
  totalArea?: number;
  /** Требуется ли отдать историю из соседних домов **/
  withNearby?: boolean;
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum ERoomsCount {
  /** Пять комнат **/
  'Five' = 'five',
  /** Четыре комнаты **/
  'Four' = 'four',
  /** Одна комната **/
  'One' = 'one',
  /** Отдельная комната(покупка/аренда отдельной комнаты в квартире) **/
  'OnlyRoom' = 'onlyRoom',
  /** Шесть и более комнат **/
  'SixPlus' = 'sixPlus',
  /** Студия **/
  'Studio' = 'studio',
  /** Три комнаты **/
  'Three' = 'three',
  /** Две комнаты **/
  'Two' = 'two',
}
